import React from 'react'
import {connect} from 'dva'
import Login from './authentication/login'
import RecoveryPassword from './authentication/recoveryPassword'
import ResetPassword from './authentication/resetPassword'
import Header from './layout/header'
import Sider from './layout/sider'
import FooterLogin from './layout/footerLogin'
import Footer from './layout/footer'
import config from '../utils/config'
import {Spin} from 'antd'
import 'antd/dist/antd.css';
import { all } from '../services/restApi'

function App({children, location, dispatch, app}) {

    const {
        user,
        currentHotel,
        login,
        buttonLoading,
        recoveryPassword,
        resetPassword,
        loading,
        sidebarCollapse,
        userMenuVisible,
        navOpenKeys
    } = app

    const loginProps = {
        buttonLoading,
        onOk(data) {
            dispatch({type: 'app/login', payload: data})
        },
        loading,
        changeRecoveryPassword() {
            dispatch({type: 'app/handleRecoveryPassword'})
        },
    }

    const recoveryPasswordProps = {
        buttonLoading,
        onOk(data) {
            dispatch({type: 'app/recoveryPassword', payload: data})
        },
        changeLogin() {
            dispatch({type: 'app/handleLogin'})
        }
    }

    const resetPasswordProps = {
        user,
        buttonLoading,
        onOk(data) {
            dispatch({type: 'app/resetPassword', payload: data})
        }
    }

    const headerProps = {
        user,
        currentHotel,
        loading,
        sidebarCollapse,
        userMenuVisible,
        logout() {
            dispatch({type: 'app/logout'})
        },
        toggleMenu() {
            dispatch({type: 'app/handleToggleMenu'})
        },
        toggleUserMenu() {
            dispatch({type: 'app/handleToggleUserMenu'})
        }
    }

    const siderProps = {
        user,
        currentHotel,
        location,
        sidebarCollapse,
        navOpenKeys,
        changeOpenKeys(openKeys) {
            localStorage.setItem('navOpenKeys', JSON.stringify(openKeys))
            dispatch({
                type: 'app/handleNavOpenKeys',
                payload: {
                    navOpenKeys: openKeys
                }
            })
        }
    }

    // Cehca si se está recuperando la contraseña
    if (location.query.token && !resetPassword) {

        all('_User', {
            where: {
                token: location.query.token,
                tokenVigency: {
                    $gte: {__type: 'Date', iso: new Date().getTime()}
                }
            }
        }).then((resp) => {
            if (resp.results.length > 0) {
                dispatch({type: 'app/handleResetPassword', payload: {user: resp.results[0]}})
            }
        })

    } 


    /**
    * Vistas del login
    */
    if (!login && !resetPassword) {
        return (
            <div className={'login-page'}>
                <div className={"login-box"}>
                    <Login {...loginProps} />
                </div>
                <FooterLogin />
            </div>
        )

    } else if (recoveryPassword) {
        return (
            <div className={'login-page'}>
                <div className={"login-box"}>
                    <RecoveryPassword {...recoveryPasswordProps} />
                </div>
                <FooterLogin />
            </div>
        )

    } else if (resetPassword) {
        return (
            <div className={'login-page'}>
                <div className={"login-box"}>
                    <ResetPassword {...resetPasswordProps} />
                </div>
                <FooterLogin />
            </div>
        )

    } else if ((!config.needLogin || login)) {
        return (
            <div className={'no-login hold-transition skin-blue sidebar-mini ' + (sidebarCollapse ? 'sidebar-collapse' : '')} >
                <Spin tip='Cargando...' spinning={loading} size='large'>
                    <div className="wrapper">
                        <Header {...headerProps} />
                        <Sider {...siderProps} />
                        {children}
                        <Footer />
                    </div>
                </Spin>
            </div>
        )
    }
}

export default connect(({app}) => ({app}))(App)


// WEBPACK FOOTER //
// ./src/components/app.js